import { render, staticRenderFns } from "./complete-substitute-teacher-invitation.view.vue?vue&type=template&id=b1bba846&scoped=true&"
import script from "./complete-substitute-teacher-invitation.view.ts?vue&type=script&lang=ts&"
export * from "./complete-substitute-teacher-invitation.view.ts?vue&type=script&lang=ts&"
import style0 from "./complete-substitute-teacher-invitation.view.scss?vue&type=style&index=0&id=b1bba846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bba846",
  null
  
)

export default component.exports